import { render } from "./GroupDetails.vue?vue&type=template&id=079baef0&scoped=true&lang=pug"
import script from "./GroupDetails.vue?vue&type=script&lang=js"
export * from "./GroupDetails.vue?vue&type=script&lang=js"

import "./GroupDetails.vue?vue&type=style&index=0&id=079baef0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079baef0"]])

export default __exports__